<template>
  <div>
    <el-radio-group :class="{'paymentType-group': true, 'is-vertical': direction === 'vertical'}" v-model="paymentType">
      <div v-if="direction === 'horizontal'">
        <span class="paymentType-item" :class="{'no-label': nolabel}" v-for="(item, index) in GLOBAL.enumPaymentType.getOptionsForCheckpay()" :key="index">
          <el-radio name="paymentType" :disabled="readonly || data.paymentAmount == 0" :label="item.value">
            <span>{{item.desc}}</span>
          </el-radio>
          <el-link :underline="false" :disabled="readonly || data.paymentAmount == 0" @click="onPaymentTypeIconClick(item.value)">
            <el-tooltip effect="light" placement="top" :content="item.desc" :manual="!nolabel">
              <i class="icon">
                <img :src="paymentImgList[item.key]" />
              </i>
            </el-tooltip>
          </el-link>
        </span>
      </div>
      <div v-else>
        <table>
          <tr class="paymentType-item" :class="{'no-label': nolabel}" v-for="(item, index) in GLOBAL.enumPaymentType.getOptionsForCheckpay()" :key="index">
            <td>
              <el-radio name="paymentType" :disabled="readonly || data.paymentAmount == 0" :label="item.value">
                <span>{{item.desc}}</span>
              </el-radio>
            </td>
            <td>
              <el-link :underline="false" :disabled="readonly || data.paymentAmount == 0" @click="onPaymentTypeIconClick(item.value)">
                <el-tooltip effect="light" placement="top" :content="item.desc" :manual="!nolabel">
                  <i class="icon">
                    <img :src="paymentImgList[item.key]" />
                  </i>
                </el-tooltip>
              </el-link>
            </td>
          </tr>
        </table>
      </div>
    </el-radio-group>
    <el-button v-if="direction === 'horizontal'" v-show="!readonly && data.paymentAmount> 0" type="primary" size="medium" :disabled="!paymentType"
      @click="onPayClick">付款
    </el-button>
    <div v-else>
      <el-button v-show="!readonly && data.paymentAmount> 0" type="primary" size="medium" :disabled="!paymentType" @click="onPayClick">付款</el-button>
    </div>
    <qrCodeViewer key="qrCodeViewer" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="qrCodeViewerDataIn" @success="onQRCodeViewerSuccess" />
  </div>
</template>

<script>
import { getPaymentImgList } from "@/config/mUtils.js";

export default {
  name: "payment",
  components: {
    qrCodeViewer: () => import("@/components/payApi/qrCodeViewer"),
  },
  props: {
    direction: {
      type: String,
      default: "vertical",
      validator: (value) => ["horizontal", "vertical"].contains(value),
    },
    nolabel: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      workflowId: Number,
      paymentAmount: Number,
      paymentType: Number,
      description: String,
    },
  },
  data() {
    return {
      paymentType: null,
      qrCodeViewerDataIn: {
        workflowId: 0,
        paymentAmount: 0,
        paymentType: null,
        description: null,
      },
    };
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.paymentType = this.data.paymentType;
    },
    onPaymentTypeIconClick(typeId) {
      this.paymentType = typeId;
    },
    onPayClick() {
      if (!this.paymentType) {
        this.$message.warning("请选择付款方式");
        return;
      }

      this.qrCodeViewerDataIn = {
        workflowId: this.data.workflowId,
        paymentAmount: this.data.paymentAmount,
        paymentType: this.paymentType,
        description: this.data.description,
      };

      this.openQRCodeViewer();
    },
    openQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.showDialog();
    },
    closeQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.closeDialog();
    },
    onQRCodeViewerSuccess(paymentRequestId) {
      let dataOut = {
        paymentRequestId,
        paymentType: this.paymentType,
      };
      this.$emit("success", dataOut);
      setTimeout(() => {
        this.closeQRCodeViewer();
      }, 5000);
    },
  },
  watch: {
    data() {
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
.paymentType-group {
  line-height: 48px;
  margin-right: 20px;

  &.is-vertical {
    margin-right: 0;
    margin-bottom: 20px;

    .paymentType-item {
      margin-right: 0;
      padding: 10px 0;
    }
  }

  .paymentType-item {
    margin-right: 10px;

    .icon {
      padding: 0;
      width: 32px;
      height: 32px;
      cursor: pointer;

      img {
        vertical-align: middle;
        text-align: center;
        width: 32px;
        height: 32px;
      }
    }

    &.no-label {
      .el-radio {
        /deep/ .el-radio__label {
          display: none;
        }
      }
    }
  }

  .el-radio {
    vertical-align: middle;
    text-align: center;
    margin: 0;
    padding: 0 8px;
  }

  .el-link {
    &.is-disabled {
      opacity: 0.5;

      .icon {
        cursor: not-allowed;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payApi/payment.vue